import React, { Component } from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    console.error('Error caught by boundary:', error, info);
    this.setState({ hasError: true });
    // Report the render-tree crash to Sentry with the React component
    // stack attached. No-op when Sentry wasn't initialized (no DSN) —
    // captureException simply drops the event in that case.
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info?.componentStack } },
    });
  }

  render() {
    if (this.state.hasError) {
      // You can customize the error message or UI here
      return <div>Something went wrong. Please refresh the page.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;





